/**
 * The default error message.
 * @type {string}
 */
export const defaultErrorMessage = 'An error occurred';

/**
 * Converts an exception object to an error message string.
 * @param {Object} exception
 * @param {string|object} fallbackMessage
 * @returns {string}
 */
export const toErrorMessage = (exception, fallbackMessage) =>
    (exception
        ? (exception.response?.data?.detail ?? exception.response?.data) ||
          (fallbackMessage ??
              (exception.data?.error ||
                  exception.message ||
                  exception.statusText))
        : fallbackMessage) || defaultErrorMessage;

/**
 * The default fetch error message.
 * @type {string}
 */
export const defaultFetchErrorMessage =
    'An error occurred while retrieving data';

/**
 * @param {Object} exception
 * @param {string} fallbackMessage
 * @returns {string}
 */
export const toFetchErrorMessage = (exception, fallbackMessage) =>
    toErrorMessage(exception, fallbackMessage || defaultFetchErrorMessage);

/**
 * Rejects a page request with an error message
 * @param {Object} params info and details
 * @returns {Promise<object>} rejected
 */
export const rejectPageRequest = params => {
    return Promise.reject({
        response: {
            // statusText: 'Invalid request',
            data: {
                ...params,
                detail: 'Invalid page request'
            }
        }
    });
};
